export enum SiteColor {
  Text = 'color-5',
}
